import {numberToHex} from 'web3-utils';

const config = {
    symbolName: process.env.REACT_APP_SYMBOL || 'BNB',
    networkName: process.env.REACT_APP_NETWORK_NAME || 'Binance Smart Chain',
    backendApiBaseUrl: process.env.REACT_APP_BACKEND_API_BASE_URL || 'https://nft.infodriver.io:8048/api/',
    rpc: process.env.REACT_APP_BACKEND_RPC_URL || 'https://bsc-dataseed.binance.org',
    explorer: process.env.REACT_APP_EXPLORER || 'https://bscscan.com/',
    networkId: process.env.REACT_APP_NETWORK_ID || 56,
    ipfsUri: process.env.REACT_APP_IPFS_URI || 'https://ipfs.qbein.net/ipfs/',
    faucetUrl: process.env.REACT_APP_FAUCET_URL ?? 'https://www.gnosisfaucet.com'
}
config.explorer = config.explorer.replace(/\/$/g, '')
config.network = {
    chainId: numberToHex(config.networkId),
    chainName: config.networkName,
    nativeCurrency: {
        name: config.networkName,
        symbol: config.symbolName,
        decimals: process.env.REACT_APP_NETWORK_DECIMALS || 18
    },
    rpcUrls: [],
    blockExplorerUrls: [],
    iconUrls: []
}

config.network.rpcUrls.push(config.rpc);
config.network.blockExplorerUrls.push(config.explorer);
config.network.iconUrls.push(process.env.REACT_APP_NETWORK_LOGO || 'https://s2.coinmarketcap.com/static/img/coins/64x64/1839.png');

export default config;

